export default "__VITE_ASSET__BJHRcW40__"